﻿import { useQuery } from '@tanstack/react-query';
import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes, CompanyPropertyDisplayNames } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import HistorySection from '../common/history/HistorySection';
import HistoryTypeSelect from '../common/history/HistoryTypeSelect';

const companyHistorySections = [
    {
        key: 'general',
        heading: 'General Information',
        renderOptions: { propertyDisplayNames: CompanyPropertyDisplayNames },
    },
    {
        key: 'companyTypes',
        heading: 'Company Types',
        renderOptions: { propertyDisplayNames: CompanyPropertyDisplayNames },
    },
    {
        key: 'billingGroups',
        heading: 'Billing Groups',
        renderOptions: { propertyDisplayNames: CompanyPropertyDisplayNames },
    },
    {
        key: 'chargeTypeBillingRates',
        heading: 'Charge Type Billing Rates',
        renderOptions: { propertyDisplayNames: CompanyPropertyDisplayNames },
    },
    {
        key: 'chargeTypeGroupBillingRates',
        heading: 'Charge Type Group Billing Rates',
        renderOptions: { propertyDisplayNames: CompanyPropertyDisplayNames },
    },
    {
        key: 'minimumWageRates',
        heading: 'Minimum Wage Rates',
        renderOptions: {
            simpleDate: true,
            propertyDisplayNames: CompanyPropertyDisplayNames,
        },
    },
    {
        key: 'subcontractorCustomers',
        heading: 'Subcontractor Customers',
        renderOptions: { propertyDisplayNames: CompanyPropertyDisplayNames },
    },
    {
        key: 'contacts',
        heading: 'Contacts',
        renderOptions: { propertyDisplayNames: CompanyPropertyDisplayNames },
    },
    {
        key: 'contactTypes',
        heading: 'Contact Types',
        renderOptions: { propertyDisplayNames: CompanyPropertyDisplayNames },
    },
];

const companyHistoryTypeOptions = [
    { value: 'all', label: 'All versions' },
    ...companyHistorySections.map((section) => ({
        value: section.key,
        label: section.filterLabel ?? section.heading,
    })),
];

const CompanyHistoryForm = ({
    id = 'companyHistoryForm', show, companyId, onClose,
}) => {
    const { data: fullHistory = {}, isFetching: loading } = useQuery({
        queryKey: ['companyFullHistory', companyId],
        queryFn: () => httpClient.js(ApiRoutes.companyHistory.byId(companyId)),
        enabled: show && Boolean(companyId),
    });

    return (
        <SlideForm
            loading={loading}
            show={show}
            id={id}
            formIcon={faTasks}
            formTitle="Company History"
            onClose={onClose}
            initialValues={{ versionHistorySection: 'all' }}
            saveDisabled
            className="history-form"
        >
            {({ values }) => {
                const selectedSection = values.versionHistorySection ?? 'all';

                return (
                    <div className="w-100">
                        <HistoryTypeSelect options={companyHistoryTypeOptions} />

                        <HistorySection
                            historicalChangeCollection={fullHistory[selectedSection]}
                            renderOptions={{ propertyDisplayNames: CompanyPropertyDisplayNames }}
                        />
                    </div>
                );
            }}
        </SlideForm>
    );
};

export default CompanyHistoryForm;
